<template>
    <div class="animated fadeIn">
      <b-row>
        <b-col md="12">
          <b-card>

            <template #header>
              <strong>Available Vehicle Dashboard</strong>
            </template> 

            
            <div class="mb-3 d-flex align-items-center" v-if="this.userType===1">
                <b-form-select
                  id="hub-select"
                  v-model="selectedHubId"
                  @change="updateSelectedHub(selectedHubId)"
                  class="wide-select"
                  style="width: 200px;" 
                >
                  <option disabled value="">Select Hub</option>
                  <option
                    v-for="hub in hubOptions"
                    :key="hub.hubid"
                    :value="hub.hubid"
                  >
                    {{ hub.hubname }}
                  </option>
                </b-form-select>
                <b-button
                  @click="clearSearch()"
                  size="md"
                  variant="danger"
                  class="ml-2"
                >
                  Clear
                </b-button>
              </div>
  
              
            <div class="hub-grid">
              <div
                class="hub-card"
                v-for="(hub, index) in hubs"
                :key="index"
                @click="openModal(hub.hubid,hub.hubname)"
              >
                <h3>{{ hub.hubname }}</h3>
                <p>{{ hub.vehicle_count }} vehicle(s)</p>
              </div>
            </div>
            <div v-if="!hubs || hubs.length === 0" style="color: red;">
              No available vehicle found.
            </div>
          </b-card>
        </b-col>
      </b-row>
  
      <!-- Modal -->
      <b-modal
        id="vehicle-modal"
        :title="selectedHub + ' - Vehicles'"
        v-model="showModal"
        size="lg"
        hide-footer
      >
        <div v-if="selectedHub">
          <table class="table">
            <thead>
              <tr>
                <th>Vehicle Number</th>
                <th>Size</th>
                <th>Type</th>
                <th>Transporter Name</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(vehicle, idx) in hubDetails" :key="idx">
                <td>{{ vehicle.vehiclenumber }}</td>
                <td>{{ vehicle.vehiclesize }}</td>
                <td>{{ vehicle.vehicletype }}</td>
                <td>{{ vehicle.transportername }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else>
          <p>No vehicles available for this hub.</p>
        </div>
      </b-modal>
    </div>
  </template>
  
  <script>
  import CONSTANTS from '@/utils/constants';
  export default {
    name: 'availableVehicleList',
    data() {
      return {
        selectedHubId:'',
        hubOptions:[],
        hubDetails:[],
        hubs: [],
        selectedHub: null,
        showModal: false,
        userType:0,
        adminHub:0,

      };
    },
    created (){
      
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      this.userType = userInfo.user_type;
      console.log("USER TYPE-------------->>>>>>>>>",this.userType)
      this.adminHub = userInfo.hub_id;
        this.allHubList();
        if(this.userType==2){
          this.getAttendanceDashboardHubList(this.adminHub);
        }else{
        this.getAttendanceDashboardHubList();
        }
        
    },
    methods: {
      openModal(hub,name) {
        this.selectedHub = name;
        this.showModal = true;
        this.getAttendanceDashboardDetails(hub);

      },
      allHubList:function(){          
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)            
        var csvObj = {
            sysusermasterid:`${userInfo.sysusermasterid}`,
            usertype:`${userInfo.user_type}`
        };
        this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAllHubListing`, csvObj)
            .then(result => {                
            if (result.body.returnmsg === 'Successful') {
                this.optionsHub=[];                
                this.HubData  = result.body.returnvalue;
                this.hubOptions  = result.body.returnvalue;                    
                for(let j = 0; j < this.HubData.length; j++) {
                    let hub = {
                        label: this.HubData[j].hubname + " - " + this.HubData[j].hubid,
                        key: this.HubData[j].hubid,
                    }
                this.optionsHub.push(hub);
                }                
            } else {              
                this.HubData  = result.body.returnvalue;
                this.hubOptions=[];
            }
        })
        .catch(ex => {
            console.log("error-----", ex);
        });
    },

    getAttendanceDashboardDetails:function(hubid){
     var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)       
      const obj ={
        hub_id : hubid
      }
      this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/vehicleAttendanceDashboardDetails`,obj)
            .then(result => {                
            if (result.body.returnmsg === 'Successful') {
                this.hubDetails=result.body.returnvalue;
                console.log(" this.hubDetails----->>>>>>>", this.hubDetails);  
                                                    
            } else {              
                this.hubDetails=[];
              
            }
        })
        .catch(ex => {
            console.log("error-----", ex);
        });
    },

    getAttendanceDashboardHubList:function(hubid){
     var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)  
      
      const obj ={
        hub_id:hubid
      }
      
      this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/vehicleAttendanceDashboardHubList`,obj)
            .then(result => {                
            if (result.body.returnmsg === 'Successful') {
                this.hubs=result.body.returnvalue;
                console.log(" this.hubs----->>>>>>>", this.hubs);  
                                                    
            } else {              
                this.hubs=[];
            }
        })
        .catch(ex => {
            console.log("error-----", ex);
        });
    },

    updateSelectedHub(hubid){
        this.getAttendanceDashboardHubList(hubid);
    },
    clearSearch(){
      this.selectedHubId='';
      this.getAttendanceDashboardHubList();
    }
    }
  };
  </script>
  
  <style>
  body {
    font-family: Arial, sans-serif;
    margin: 0;
  }
  
  .container {
    max-width: 1000px;
    margin: auto;
  }
  
  h1 {
    text-align: center;
    margin-bottom: 30px;
  }
  
  .hub-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 20px;
  }
  
  .hub-card {
    background: white;
    padding: 20px;
    border-radius: 12px;
    box-shadow: 0px 3px 14px 2px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    transition: transform 0.2s;
  }
  
  .hub-card:hover {
    transform: scale(1.03);
  }
  
  .hub-card h3 {
    margin: 0 0 10px;
  }
  
  table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 15px;
  }
  
  table, th, td {
    border: 1px solid #ddd;
  }
  
  th, td {
    padding: 10px;
    text-align: left;
  }
  </style>
  